import React, { useState } from 'react';
import JumbledSentenceExercise from './JumbledSentenceExercise';
import './JumbledSentenceExerciseBoard.css';

const BOARD_ICON = (
  <span style={{
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    width: 48, height: 48, borderRadius: 12,
    background: 'linear-gradient(135deg, #0284c7 0%, #0ea5e9 100%)', marginRight: 20,
  }}>
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="16 3 21 3 21 8"/><line x1="4" y1="20" x2="21" y2="3"/>
      <polyline points="21 16 21 21 16 21"/><line x1="15" y1="15" x2="21" y2="21"/>
      <line x1="4" y1="4" x2="9" y2="9"/>
    </svg>
  </span>
);

const JumbledSentenceExerciseBoard = ({
  exerciseData, onUpdate, isSelected, onSelect, onExpand,
  isExpanded: isExpandedProp, onClose,
  isStudent = false, myState = {}, otherState = {}, updateState = () => {},
}) => {
  const [isExpandedLocal, setIsExpandedLocal] = useState(false);
  const isExpanded = isExpandedProp !== undefined ? isExpandedProp : isExpandedLocal;
  const { sentences, title, level } = exerciseData || {};

  if (!sentences || !Array.isArray(sentences)) {
    return <div className="js-board-error"><p>Error: Invalid Word Order exercise data</p></div>;
  }

  return (
    <div className="js-exercise-board">
      {!isExpanded ? (
        <div
          className={`js-board-preview unified-exercise-preview js-board-card${isSelected ? ' is-selected' : ''}`}
          onClick={() => {
            if (isExpandedProp === undefined) setIsExpandedLocal(true);
            if (onSelect) onSelect();
            if (onExpand) onExpand();
          }}
        >
          {BOARD_ICON}
          <div className="unified-preview-main">
            <div className="unified-preview-title">{title || 'Word Order Exercise'}</div>
            <div className="unified-preview-meta">
              {sentences.length} sentence{sentences.length !== 1 ? 's' : ''} · Level: {level || 'B1'}
            </div>
          </div>
          <button className="unified-preview-btn">Start Exercise</button>
        </div>
      ) : (
        <div className="js-board-expanded">
          <JumbledSentenceExercise
            sentences={sentences}
            title={title}
            level={level}
            onClose={() => {
              if (isExpandedProp === undefined) setIsExpandedLocal(false);
              if (onClose) onClose();
            }}
            onUpdate={onUpdate}
            isBoard={true}
            isStudent={isStudent}
            myState={myState}
            otherState={otherState}
            updateState={updateState}
          />
        </div>
      )}
    </div>
  );
};

export default JumbledSentenceExerciseBoard;
